export default __webpack_public_path__ + "static/media/limited.edeab200.png";